import React, { useEffect } from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';
import { PaymentCycleList } from './list';
import { PayCycleAccEntryList } from './AccountingEntry/list';
import { globalMode } from 'utility/cache/ui';
import { clearPayCycleState, keepPayCycleStateOnExit } from './view/utility/payCycleListState';

export type PayCycleView = 'Signing' | 'Accounting' | 'History';

export const payCycleMode = makeVar<PayCycleView>('Signing');

export const PayCycle: React.FC = () => {
  const globalState = useReactiveVar(globalMode);
  const mode = useReactiveVar(payCycleMode);
  if (!mode && globalState) payCycleMode('Signing');
  useEffect(() => {
    return () => {
      if (keepPayCycleStateOnExit()) {
        // user opened a payment from Pay Cycles: keep state, remove the flag
        keepPayCycleStateOnExit(false);
        return;
      }
      // any other exit : reset
      payCycleMode('Signing');
      clearPayCycleState();
    };
  }, []);

  return (
    <>
      {mode === 'Signing' && <PaymentCycleList />}
      {(mode === 'Accounting' || mode === 'History') && (
        <PayCycleAccEntryList key={mode} />
      )}
    </>
  );
};